import React from 'react'
import PropTypes from 'prop-types'
import { BeliefsPageTemplate } from '../../templates/beliefs-page'

const BeliefsPagePreview = ({ entry, getAsset, widgetFor }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <BeliefsPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        title={entry.getIn(['data', 'title'])}
        content={widgetFor('body')}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

BeliefsPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default BeliefsPagePreview
